import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=f4508dd0"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports